import React from "react";
import {ReactComponent as LogoIcon} from "../../icons/logo.svg";
import {useNavigate} from "react-router-dom";

const FooterContent = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer-content">
      <div className="footer-content-logo">
        <LogoIcon className="footer-logo-icon cursor-pointer" onClick={() => navigate("/")}/>
      </div>

      <ul className="footer-content-links menu-text">
        <li><a href="/">Контакты</a></li>
        <li><a href="/">Публичное соглашение</a></li>
        <li><a href="/">Карта сайта</a></li>
        <li><a href="/">Юридическая информация</a></li>
        <li><a href="/">Политика конфиденциальности</a></li>
      </ul>
    </footer>
  );
};

export default FooterContent;